"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectCellFactory = void 0;
const react_1 = require("react");
function useSelectCellFactory(dataHook) {
    const source = dataHook();
    return (0, react_1.useMemo)(() => {
        const selectColumnMapper = function selectColumnMapper({ value, }) {
            const item = source.items.find((v) => v.id === value);
            return item === null || item === void 0 ? void 0 : item.name;
        };
        // store current items into the function object for easy retrieval during export generation
        selectColumnMapper.displayName = 'selectColumnMapper';
        selectColumnMapper.data = source.items;
        return selectColumnMapper;
    }, [source.items]);
}
exports.useSelectCellFactory = useSelectCellFactory;
//# sourceMappingURL=select-column-mapper.js.map